import moment from 'moment'

export const getReplyValue = reply => {
  if (!reply) {
    return
  }
  if (reply.question.type.name === 'sign') {
    return reply.value.name
  }
  return reply.value
}

export const getAddressValue = serviceOrder => {
  if (!serviceOrder.address) {
    const fieldFound = serviceOrder.place.fieldValues.find(fieldValue => fieldValue.field.name === 'Endereço')
    if (!fieldFound) {
      return '**N/A**'
    }
    return fieldFound.value.search
  }

  return serviceOrder.address.search
}

export const getPlaceFieldValue = (place, fieldValueName) => {
  const fieldFound = place.fieldValues.find(fieldValue => fieldValue.field.name === fieldValueName)
  if (!fieldFound) {
    return ''
  }
  return fieldFound.value
}

export const findReplyByQuestionIds = (replies, questionId) => {
  return replies.find(reply => questionId.includes(reply.question.id))
}

export const findReplyByQuestionId = (replies, questionId) => {
  return replies.find(reply => reply.question.id === questionId)
}

export const addBusinessDays = (originalDate, numDaysToAdd) => {
  const date = moment.isMoment(originalDate) ? originalDate : moment(originalDate)
  const sunday = 0
  const saturday = 6
  let daysRemaining = numDaysToAdd - 1

  const newDate = date.clone()

  while (daysRemaining > 0) {
    newDate.add(1, 'days')
    if (newDate.day() !== sunday && newDate.day() !== saturday) {
      daysRemaining--
    }
  }

  return newDate
}

export const toCurrency = value => {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })

  return formatter.format(value)
}

export const sumAllTotalAmount = data => {
  const { services, equipments } = data
  const totalAmounts = [...services, ...equipments].map(item => item.totalAmount)

  return totalAmounts.reduce((sum, amount) => sum + amount, 0)
}

export const sumEquipmentTotalAmount = array => {
  return array.equipments.reduce((sum, item) => sum + item.totalAmount, 0)
}

export const sumServiceTotalAmount = array => {
  return array.services.reduce((sum, item) => sum + item.totalAmount, 0)
}

const servicesServiceQuestions = [
  2910, 2969, 2765, 2787, 3444, 3454, 2913, 2976, 2772, 2794, 3447, 3457, 2916, 2997, 3450, 3460, 2919, 2983, 2990,
  3004, 3011, 3018, 2779, 2801, 5718
]
const servicesAmountQuestions = [
  2911, 2970, 2766, 2788, 3445, 3455, 2914, 2977, 2773, 2795, 3448, 3458, 2917, 2998, 3451, 3461, 2920, 2984, 2991,
  3005, 3012, 3019, 2780, 2802, 5719
]
const servicesUnitPricesQuestions = [
  5524, 5540, 5363, 5375, 5330, 5336, 5526, 5544, 5367, 5379, 5332, 5338, 5528, 5556, 5334, 5340, 5530, 5548, 5552,
  5560, 5564, 5574, 5371, 5383, 5725
]
const servicesTotalAmountQuestions = [
  5525, 5541, 5364, 5376, 5331, 5337, 5527, 5545, 5368, 5380, 5333, 5339, 5529, 5557, 5335, 5341, 5531, 5549, 5553,
  5561, 5565, 5575, 5372, 5384, 5726
]

const equipmentsServiceQuestions = [
  2972, 2923, 2768, 2790, 3464, 2979, 2926, 2775, 2797, 3467, 3000, 2929, 3470, 2932, 3473, 2986, 2993, 3007, 3014,
  3021, 2782, 2804
]

const equipmentsAmountQuestions = [
  2973, 2924, 2769, 2791, 3465, 2980, 2927, 2776, 2798, 3468, 3001, 2930, 3471, 2933, 3474, 2987, 2994, 3008, 3015,
  3022, 2783, 2805
]

const equipmentsUnitPriceQuestions = [
  5542, 5532, 5365, 5377, 3465, 5546, 5534, 5369, 5381, 5344, 5558, 5536, 5346, 5538, 5348, 5550, 5554, 5562, 5566,
  5576, 5373, 5385
]

const equipmentsTotalAmount = [
  5543, 5533, 5366, 5378, 5343, 5547, 5535, 5370, 5382, 5345, 5559, 5537, 5347, 5539, 5349, 5551, 5555, 5563, 5567,
  5577, 5374, 5386
]

const servicesBlockQuestions = [
  2909, 2968, 2764, 2786, 3443, 3453, 2912, 2975, 2771, 2793, 3446, 3456, 2915, 2996, 3449, 3459, 2918, 2982, 2989,
  3003, 3010, 3017, 2778, 2800, 7670
]
const equipmentsBlockQuestions = [
  2971, 2922, 2767, 2789, 3463, 2978, 2925, 2774, 2796, 3466, 2999, 2928, 3469, 2931, 3472, 2985, 2992, 3006, 3013,
  3020, 2781, 2803
]

export const separateRepliesByInvoiceType = array => {
  return array.reduce((acc, replies) => {
    const questionId = replies.question.id
    acc['equipments'] = acc['equipments'] || []
    acc['services'] = acc['services'] || []

    if (equipmentsBlockQuestions.includes(questionId)) {
      const repliesValue = replies.value.map(item => {
        const amount = item.find(i => equipmentsAmountQuestions.includes(i.questionId))?.value
        const unitPrice = item.find(i => equipmentsUnitPriceQuestions.includes(i.questionId))?.value
        const totalAmount = item.find(i => equipmentsTotalAmount.includes(i.questionId))?.value
        const service = item.find(i => equipmentsServiceQuestions.includes(i.questionId))?.value?.name
        return {
          amount,
          unitPrice,
          totalAmount,
          service
        }
      })
      acc['equipments'].push(...repliesValue)
    }
    if (servicesBlockQuestions.includes(questionId)) {
      const repliesValue = replies.value.map(item => {
        const amount = item.find(i => servicesAmountQuestions.includes(i.questionId))?.value
        const unitPrice = item.find(i => servicesUnitPricesQuestions.includes(i.questionId))?.value
        const totalAmount = item.find(i => servicesTotalAmountQuestions.includes(i.questionId))?.value
        const service = item.find(i => servicesServiceQuestions.includes(i.questionId))?.value?.name
        return {
          amount,
          unitPrice,
          totalAmount,
          service
        }
      })
      acc['services'].push(...repliesValue)
    }
    return acc
  }, {})
}

export const formatEnglishShortDate = dateString => {
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' })
}

export const formatEnglishCompleteDate = dateString => {
  const date = new Date(dateString)
  return date
    .toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'short',
      year: '2-digit'
    })
    .replace(',', '-')
    .replace(' ', '-')
}

export const formatEnglishDate = dateString => {
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
}

export const filterRepliesByParentReference = (replies, reference) => {
  return replies.filter(
    reply => reply.question.parentReference && reply.question.parentReference.indexOf(reference) === 0
  )
}

export const getRepliesFromBlockQuestion = (replies, blockIndex) => {
  return replies.filter(reply => reply.blockIndex === blockIndex)
}

export const sumAmount = (array, key) => {
  return array.reduce((sum, item) => sum + item[key], 0)
}

export const formatEnglishNumber = number => {
  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(number)
}

export const formatDollar = number => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(number)
}
